import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostImportProductNetLatestList } from '@/services/wms/product';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      btnLoading: false,
      searchForm: {
        productName: undefined
      },
      listRequest: rqtPostImportProductNetLatestList,
      codeResItems: []
    };
  },
  mounted() {
    this.initResCodeType(this.codeResItems);
  },
  methods: {
    onSearch() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    }
  }
};